import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, shareReplay } from "rxjs";
import { environment } from "src/environments/environment";
import { StatusCliente } from "../model/status.model";
import { CustomMessage } from "../model/custom-message.model";

@Injectable({
  providedIn: "root",
})
export class StatusConfigService {
  private _apiUrl = environment.apiUrl + "/v1";
  private cachedStatusMessages$: Observable<StatusCliente[]> | null = null;
  private cachedCustomMessages$: Observable<CustomMessage[]> | null = null;
  constructor(private httpClient: HttpClient) { }

  getStatusMessages() {
    if (!this.cachedStatusMessages$) {
      this.cachedStatusMessages$ = this.httpClient
        .get<StatusCliente[]>(`${this._apiUrl}/StatusClientes`)
        .pipe(shareReplay(1));
    }
    return this.cachedStatusMessages$;
  }

  createStatusMessage(status: StatusCliente): Observable<StatusCliente> {
    status.nome = `${status.nome}|${status.cor}`;

    return this.httpClient.post<StatusCliente>(
      `${this._apiUrl}/StatusClientes`,
      status,
    );
  }

  editStatusMessage(id: string, status: StatusCliente): Observable<StatusCliente> {
    status.nome = `${status.nome}|${status.cor}`;

    return this.httpClient.put<StatusCliente>(
      `${`${this._apiUrl}/StatusClientes`}/${id}`,
      status,
    );
  }
  deleteStatusMessage(id: string): Observable<StatusCliente> {
    return this.httpClient.delete<StatusCliente>(
      `${`${this._apiUrl}/StatusClientes`}/${id}`,
    );
  }

  getCustomMessages() {
    if (!this.cachedCustomMessages$) {
      this.cachedCustomMessages$ = this.httpClient
        .get<CustomMessage[]>(`${this._apiUrl}/MensagensPersonalizadas`)
        .pipe(shareReplay(1));
    }
    return this.cachedCustomMessages$;
  }
  createCustomMessage(customMessage: CustomMessage): Observable<CustomMessage> {
    return this.httpClient.post<CustomMessage>(
      `${this._apiUrl}/MensagensPersonalizadas`,
      customMessage,
    );
  }
  editCustomMessage(
    id: string,
    customMessage: CustomMessage,
  ): Observable<CustomMessage> {
    return this.httpClient.put<CustomMessage>(
      `${this._apiUrl}/MensagensPersonalizadas/${id}`,
      customMessage,
    );
  }
  deleteCustomMessage(id: string): Observable<CustomMessage> {
    return this.httpClient.delete<CustomMessage>(
      `${this._apiUrl}/MensagensPersonalizadas/${id}`,
    );
  }
}
